import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Paper,
  CircularProgress,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import api from "../../api";

const EmailSubscriptions = () => {
  const [subscriptions, setSubscriptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const fetchSubscriptions = async () => {
    setLoading(true);
    setError("");
    try {
      const res = await api.get("/admin/subscriptions");
      const rows = Array.isArray(res.data?.data) ? res.data.data : [];
      setSubscriptions(rows);
    } catch (err) {
      setError(err.response?.data?.message || "Failed to load subscriptions.");
      setSubscriptions([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSubscriptions();
  }, []);

  return (
    <Box p={3}>
      <Typography variant="h5" mb={3}>
        Email Subscriptions
      </Typography>

      {error ? (
        <Paper sx={{ p: 2, mb: 3, bgcolor: "#ffebee", color: "#b71c1c" }}>
          {error}
        </Paper>
      ) : null}

      {loading ? (
        <Box display="flex" justifyContent="center" p={5}>
          <CircularProgress />
        </Box>
      ) : (
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Name</TableCell>
                <TableCell>Email</TableCell>
                <TableCell>Source</TableCell>
                <TableCell>Subscribed Date</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {subscriptions.length > 0 ? (
                subscriptions.map((item) => (
                  <TableRow key={item.id} hover>
                    <TableCell>{item.name || "-"}</TableCell>
                    <TableCell>{item.email}</TableCell>
                    <TableCell>{item.source || "-"}</TableCell>
                    <TableCell>
                      {item.created_at ? new Date(item.created_at).toLocaleString() : "-"}
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={4} align="center">
                    No subscriptions found.
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </Box>
  );
};

export default EmailSubscriptions;

